var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsaap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.512157 12.4764C0.511594 14.4929 1.04259 16.4618 2.05228 18.1973L0.415594 24.1267L6.53109 22.5357C8.22256 23.4494 10.1177 23.9281 12.0436 23.9282H12.0487C18.4063 23.9282 23.5816 18.7949 23.5843 12.4854C23.5855 9.42804 22.3867 6.55306 20.2085 4.39009C18.0307 2.2273 15.1343 1.03558 12.0482 1.03418C5.68978 1.03418 0.514875 6.1672 0.51225 12.4764",
    fill: "url(#paint0_linear_935_180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100313 12.4728C0.0996563 14.5618 0.649687 16.6011 1.69537 18.3987L0 24.5408L6.33478 22.8927C8.08022 23.837 10.0454 24.3348 12.0451 24.3356H12.0502C18.636 24.3356 23.9972 19.0176 24 12.4823C24.0011 9.315 22.7591 6.33668 20.5031 4.09621C18.2468 1.85602 15.2468 0.62142 12.0502 0.620117C5.46337 0.620117 0.102938 5.93733 0.100313 12.4728ZM3.87281 18.0891L3.63628 17.7166C2.64197 16.1478 2.11716 14.335 2.11791 12.4735C2.12006 7.04142 6.57544 2.62198 12.054 2.62198C14.7071 2.62309 17.2005 3.64933 19.0759 5.51128C20.9512 7.37342 21.9831 9.84877 21.9824 12.4815C21.98 17.9136 17.5245 22.3336 12.0502 22.3336H12.0463C10.2638 22.3327 8.51569 21.8577 6.99113 20.9601L6.62831 20.7466L2.86912 21.7246L3.87281 18.089V18.0891Z",
    fill: "url(#paint1_linear_935_180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06356 7.51782C8.83988 7.02452 8.60447 7.01457 8.39175 7.00592C8.21756 6.99847 8.01844 6.99903 7.8195 6.99903C7.62038 6.99903 7.29684 7.07336 7.02338 7.36964C6.74963 7.6662 5.97825 8.38285 5.97825 9.84043C5.97825 11.2981 7.04822 12.7068 7.19738 12.9046C7.34672 13.1021 9.26297 16.189 12.2978 17.3765C14.8201 18.3634 15.3334 18.1671 15.8808 18.1176C16.4283 18.0683 17.6474 17.4012 17.8961 16.7094C18.145 16.0176 18.145 15.4247 18.0704 15.3008C17.9958 15.1774 17.7967 15.1032 17.4981 14.9551C17.1994 14.8069 15.7314 14.0902 15.4578 13.9913C15.184 13.8925 14.985 13.8432 14.7859 14.1399C14.5868 14.4361 14.015 15.1032 13.8407 15.3008C13.6666 15.4988 13.4923 15.5235 13.1938 15.3753C12.895 15.2267 11.9334 14.9142 10.7926 13.905C9.90497 13.1197 9.30572 12.1499 9.13153 11.8533C8.95734 11.5571 9.11288 11.3965 9.26259 11.2489C9.39675 11.1161 9.56128 10.9029 9.71072 10.73C9.85959 10.557 9.90928 10.4335 10.0088 10.236C10.1085 10.0382 10.0586 9.86517 9.98409 9.71699C9.90928 9.5688 9.32906 8.10359 9.06356 7.51782Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_180",
    x1: 1158.85,
    y1: 2310.29,
    x2: 1158.85,
    y2: 1.03418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_935_180",
    x1: 1200,
    y1: 2392.69,
    x2: 1200,
    y2: 0.620117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.620117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsaap);
export default __webpack_public_path__ + "static/media/whatsaap.93dc2e7f54fad8774bb31d2250c0ee2b.svg";
export { ForwardRef as ReactComponent };